import PropTypes from "prop-types";
import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
	changeLayout,
	changeSidebarTheme,
	changeSidebarType,
	changeTopbarTheme,
	changeLayoutWidth,
} from "../../store/actions";
import Sidebar from "./Sidebar";
import Rightbar from "../CommonForBoth/Rightbar";
import "./styles.scss";

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
			mobileSidebarOpen: false,
		};
		this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
		this.toggleMobileSidebar = this.toggleMobileSidebar.bind(this);
		this.closeMobileSidebar = this.closeMobileSidebar.bind(this);
	}

	capitalizeFirstLetter = (string) => {
		return string.charAt(1).toUpperCase() + string.slice(2);
	};

	componentDidMount() {
		if (this.props.isPreloader === true) {
			document.getElementById("preloader").style.display = "block";
			document.getElementById("status").style.display = "block";

			setTimeout(function () {
				document.getElementById("preloader").style.display = "none";
				document.getElementById("status").style.display = "none";
			}, 2500);
		} else {
			document.getElementById("preloader").style.display = "none";
			document.getElementById("status").style.display = "none";
		}

		window.scrollTo(0, 0);

		if (this.props.leftSideBarTheme) {
			this.props.changeSidebarTheme(this.props.leftSideBarTheme);
		}
		if (this.props.layoutWidth) {
			this.props.changeLayoutWidth(this.props.layoutWidth);
		}
		if (this.props.leftSideBarType) {
			this.props.changeSidebarType(this.props.leftSideBarType);
		}
		if (this.props.topbarTheme) {
			this.props.changeTopbarTheme(this.props.topbarTheme);
		}
	}

	toggleMenuCallback = () => {
		if (this.props.leftSideBarType === "default") {
			this.props.changeSidebarType("condensed", this.state.isMobile);
		} else if (this.props.leftSideBarType === "condensed") {
			this.props.changeSidebarType("default", this.state.isMobile);
		}
	};

	toggleMobileSidebar() {
		this.setState((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen }));
	}

	closeMobileSidebar() {
		this.setState({ mobileSidebarOpen: false });
	}

	render() {
		const { mobileSidebarOpen } = this.state;

		return (
			<React.Fragment>
				<div id="preloader">
					<div id="status">
						<div className="spinner-chase">
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
							<div className="chase-dot" />
						</div>
					</div>
				</div>

				<div id="layout-wrapper">
					{this.props.showLeftSidebar ? (
						<>
							{/* Mobile backdrop */}
							{/* {mobileSidebarOpen && (
								<div
									className="admin-sidebar-backdrop"
									onClick={this.closeMobileSidebar}>
									<svg
										width="22"
										height="22"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round">
										<line x1="3" y1="6" x2="21" y2="6" />
										<line x1="3" y1="12" x2="21" y2="12" />
										<line x1="3" y1="18" x2="21" y2="18" />
									</svg>
								</div>
							)} */}
							<Sidebar
								theme={this.props.leftSideBarTheme}
								type={this.props.leftSideBarType}
								isMobile={this.state.isMobile}
								mobileSidebarOpen={mobileSidebarOpen}
								closeMobileSidebar={this.closeMobileSidebar}
							/>
						</>
					) : null}

					<div
						className={
							this.props.showProfileMenu && this.props.showLeftSidebar
								? "main-content"
								: "main-content ms-2"
						}>
						{/* Mobile topbar with hamburger */}
						<div className="admin-mobile-topbar">
							<button
								className="admin-hamburger"
								aria-label="Open sidebar"
								onClick={this.toggleMobileSidebar}>
								<svg
									width="22"
									height="22"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round">
									<line x1="3" y1="6" x2="21" y2="6" />
									<line x1="3" y1="12" x2="21" y2="12" />
									<line x1="3" y1="18" x2="21" y2="18" />
								</svg>
							</button>
						</div>

						{this.props.children}
					</div>
				</div>

				{this.props.showRightSidebar ? <Rightbar /> : null}
			</React.Fragment>
		);
	}
}

Layout.defaultProps = {
	showLeftSidebar: true,
	showProfileMenu: true,
};

Layout.propTypes = {
	changeLayoutWidth: PropTypes.func,
	changeSidebarTheme: PropTypes.func,
	changeSidebarType: PropTypes.func,
	changeTopbarTheme: PropTypes.func,
	children: PropTypes.object,
	isPreloader: PropTypes.any,
	layoutWidth: PropTypes.any,
	leftSideBarTheme: PropTypes.any,
	leftSideBarType: PropTypes.any,
	location: PropTypes.object,
	showRightSidebar: PropTypes.any,
	showLeftSidebar: PropTypes.bool,
	showProfileMenu: PropTypes.bool,
	routePrefix: PropTypes.string,
	topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => {
	return {
		...state.Layout,
	};
};
export default connect(mapStatetoProps, {
	changeLayout,
	changeSidebarTheme,
	changeSidebarType,
	changeTopbarTheme,
	changeLayoutWidth,
})(withRouter(Layout));
